"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateConfigurationStore = hydrateConfigurationStore;
async function hydrateConfigurationStore(configurationStore, response) {
    if (configurationStore) {
        const didUpdate = await configurationStore.setEntries(response.entries);
        if (didUpdate) {
            configurationStore.setEnvironment(response.environment);
            configurationStore.setConfigFetchedAt(new Date().toISOString());
            configurationStore.setConfigPublishedAt(response.createdAt);
            configurationStore.setFormat(response.format);
            configurationStore.salt = response.salt;
        }
        return didUpdate;
    }
    return false;
}
//# sourceMappingURL=configuration-store-utils.js.map